@if (hasBackdrop) {
  <div
    class="cos-drawer-backdrop"
    (click)="_onBackdropClicked()"
    [class.cos-drawer-shown]="_isShowingBackdrop()"
  ></div>
}

<ng-content select="cos-drawer" />

<ng-content select="cos-drawer-content" />

@if (!_content) {
  <cos-drawer-content>
    <ng-content />
  </cos-drawer-content>
}
